import { DashboardLayout } from "@/components/layout/DashboardLayout";
import { DocumentUpload } from "@/components/DocumentUpload";

export default function Upload() {
  return (
    <DashboardLayout>
      <div className="space-y-6">
        <div>
          <h2 className="text-3xl font-bold text-foreground">Data Upload</h2>
          <p className="text-muted-foreground mt-1">
            Upload employee data and calendar information in bulk
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <DocumentUpload uploadType="employee" />
          <DocumentUpload uploadType="holiday" />
        </div>
      </div>
    </DashboardLayout>
  );
}
